import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import Basemap from "@arcgis/core/Basemap";
import ScaleBar from "@arcgis/core/widgets/ScaleBar.js";
import WMTSLayer from "@arcgis/core/layers/WMTSLayer";
import MapView from "@arcgis/core/views/MapView";
import Map from "@arcgis/core/Map";
import MapImageLayer from "@arcgis/core/layers/MapImageLayer";
import WMSLayer from "@arcgis/core/layers/WMSLayer";
import { Layout, Space } from "antd";
import { Content } from "antd/es/layout/layout";
import "@arcgis/core/assets/esri/themes/light/main.css"
import ToolBarComponent from "./ToolbarComponent";
import Locate from "@arcgis/core/widgets/Locate";
import * as reactiveUtils from "@arcgis/core/core/reactiveUtils";
import SplitPane, { Pane } from "react-split-pane";
import TableComponent from "./widgets/table/TableComponent";
import esriId from "@arcgis/core/identity/IdentityManager.js";


import SearchVM from "@arcgis/core/widgets/Search/SearchViewModel.js";
import Home from "@arcgis/core/widgets/Home.js";
import Compass from "@arcgis/core/widgets/Compass.js";
import CoordinateConversion from "@arcgis/core/widgets/CoordinateConversion.js";
import ButtonPreView from "./widgets/ButtonPreView";
import ButtonPostView from "./widgets/ButtonPostView";

import { views_state } from "../../features/views/viewsSlice";
import { addView } from "../../features/views/viewsSlice";

import ProjectParameters from "@arcgis/core/rest/support/ProjectParameters";
import { project } from "@arcgis/core/rest/geometryService";
import Point from "@arcgis/core/geometry/Point";
import OverviewMapComponent from "./widgets/OverviewMapComponent";
import { SecurityService } from "../../service/securityService";
import { getProxiedUrl } from "../../utilities/MapUtilities";
import { isMobile } from 'react-device-detect';

const sortMaplyrList = (maplyrList) => {
    if (!maplyrList) return [];
    return [...maplyrList].sort((a, b) => (a.orderPosition ?? 0) - (b.orderPosition ?? 0));
};

const SgvMapComponent = ({ mapConfig, setMapConfig }) => {
    //console.log("SgvMapComponent mapConfig", mapConfig)

    const mapRef = useRef(null);
    const tableRef = useRef(null);
    const buttonEscalaInicial = useRef(null)
    const buttonPreView = useRef(null)
    const buttonPostView = useRef(null)
    const sceneRef = useRef(null);
    const overviewDivRef = useRef(null);

    const [mapView, setMapView] = useState();
    const [basemap, setBaseMap] = useState()
    const [extent, setExtent] = useState();
    const [searchVM, setSearchVM] = useState()
    const [tableVisible, setTableVisible] = useState(false)
    const [overviewMapVisible, setOverviewMapVisible] = useState(false)
    const [tableSize, setTableSize] = useState()
    const [coordenadas, setCoordenadas] = useState("")
    const [sceneView, setSceneView] = useState();
    const [currentView, setCurrentView] = useState(0)


    const dispatch = useDispatch();
    const viewState = useSelector(views_state);

    useEffect(() => {
        //console.log('se renderiza el main')
       
        initPermissions(mapConfig)

        localStorage.getItem('sgvmap40_splitPos') ? setTableSize(window.innerHeight - parseInt(localStorage.getItem('sgvmap40_splitPos'))) : setTableSize(window.innerHeight / 2);

    }, [])

    useEffect(() => {
        //console.log('views length', viewState)
        setCurrentView(viewState.length - 1)
    }, [viewState])

    useEffect(() => {
        if (mapView) {
            if (coordenadas !== "" && coordenadas !== "new") {
                //console.log('se ejecuta coodenadas', coordenadas)
                searchVM.search(coordenadas)
                setCoordenadas("new")
            }
            if (coordenadas === "") {
                searchVM.clear()
            }
        }
    }, [coordenadas])


    const convertToWGS84 = async (point) => {

        let coordenadas = [];
        const wgs84SpatialReference = { wkid: 4326 }; // WGS 84 WKID
        const geometryServiceUrl = "https://utility.arcgisonline.com/ArcGIS/rest/services/Geometry/GeometryServer";

        const params = new ProjectParameters({
            geometries: [point],
            outSpatialReference: wgs84SpatialReference
        });

        await project(geometryServiceUrl, params)
            .then(result => {
                const wgs84Point = result[0].toJSON();

                coordenadas.push(wgs84Point.x)
                coordenadas.push(wgs84Point.y)
            })
            .catch(error => {
                console.error("Error:", error);
            });
        return coordenadas
    }

    const initPermissions = async (myMapConfig) => {
        if (myMapConfig != undefined) {

            //TODO POR AHORA NO SE UTILIZA, PERO SE DEJA POR SI SE NECESITA EN UN FUTURO POR UTILIZA SERVICIOS DE ARCGIS CON SEGURIDAD HABILIATADA
            /*
            for (let i in myMapConfig.sgvmapMapMaplyrList) {
                let mapLayer = myMapConfig.sgvmapMapMaplyrList[i].sgvmapMapLayer;
                //id de la capa

                //Se obtiene el token
                let tokenObject = await SecurityService.getTokenArcgisServer(mapLayer.idMapLayer)
                //console.log(tokenObject)



                //Si el token existe entonces se registra y se realiza la petición al servicio privado
                if (tokenObject) {
                    //INDICAMOS AL IDENTITYMANAGER QUE UTILICE EL TOKEN PARA LAS REQUEST QUE SE REALICEN A ESA URL
                    let tokenServer = {
                        "server": mapLayer.conf.url,
                        "token": tokenObject.token
                    };
                    // Realiza una solicitud a un servicio seguro usando el token
                    esriId.registerToken(tokenServer);
                }
            }*/
            initMap(mapConfig);
        }

    }


    const initMap = (myMapConfig) => {
       
        //console.log('initMap')
        const basemap = new Basemap({
            baseLayers: [
                new WMTSLayer({
                    url: myMapConfig.sgvmapMap.mapConfig.baseMap.url,//"https://www.ign.es/wmts/ign-base",
                    activeLayer: {
                        id: myMapConfig.sgvmapMap.mapConfig.baseMap.activeLayerId,//"IGNBase-gris",
                        tileMatrixSetId: myMapConfig.sgvmapMap.mapConfig.baseMap.activeLayerTileMatrix//"GoogleMapsCompatible"
                    },
                    serviceMode: myMapConfig.sgvmapMap.mapConfig.baseMap.serviceMode,
                    copyright: `<a href="https://www.ign.es/" target="_blank">Instituto Geográfico Nacional</a>`
                })
            ],
            thumbnailUrl: myMapConfig.sgvmapMap.mapConfig.baseMap.thumbnailUrl
            //"https://www.ign.es/wmts/ign-base?SERVICE=WMTS&VERSION=1.0.0&REQUEST=GetTile&LAYER=IGNBase-gris&STYLE=default&FORMAT=image%2Fjpeg&TILEMATRIXSET=GoogleMapsCompatible&TILEMATRIX=6&TILEROW=24&TILECOL=31"
        });


        setBaseMap(basemap)

        let layers = [];
       

        if (myMapConfig != undefined) {

            const sortedMaplyrList = sortMaplyrList(myMapConfig.sgvmapMapMaplyrList);

            for (let i in sortedMaplyrList) {
                let mapLayer = sortedMaplyrList[i].sgvmapMapLayer;
                
                //console.log("mapMaplyr", mapLayer);
                if (mapLayer.conf.type == "MAP_IMAGE_LAYER") {
                    //console.log("ADD MapImageLayer", mapLayer)

                    //console.log('contrseña', mapLayer.conf.password)

                    //QUITO LA OPACIDAD, YA QUE NO FUNCIONA EN DGA

                    for (var j in mapLayer.conf.sublayers) {
                        if (mapLayer.conf.sublayers[j].opacity != null && mapLayer.conf.sublayers[j].opacity == 1) {
                            delete mapLayer.conf.sublayers[j].opacity;
                        }

                    }

                    const layerUrl = getProxiedUrl(mapLayer.conf.url);
                    console.log(`[SgvMapComponent] Creando MapImageLayer '${mapLayer.name}' con URL: ${layerUrl}`);
                    
                    let layer = new MapImageLayer({
                        title: mapLayer.name,
                        description: mapLayer.description,
                        url: layerUrl,
                        sublayers: mapLayer.conf.sublayers
                    });
                    
                    // Agregar listener para errores de carga
                    layer.when(() => {
                        console.log(`[SgvMapComponent] Capa '${mapLayer.name}' cargada correctamente`);
                    }).catch((error) => {
                        console.error(`[SgvMapComponent] Error al cargar capa '${mapLayer.name}':`, error);
                        console.error(`[SgvMapComponent] URL usada: ${layerUrl}`);
                    });
                  
                    //console.log('layer name', layer)
                    //console.log('sublayers despues', layer.sublayers)
                    layers.push(layer);
                    //console.log("layers", layers)
                } else if (mapLayer.conf.type == "WMS_LAYER") {
                    //console.log("ADD WMSLayer", mapLayer)
                    const layerUrl = getProxiedUrl(mapLayer.conf.url);
                    console.log(`[SgvMapComponent] Creando WMSLayer '${mapLayer.name}' con URL: ${layerUrl}`);
                    
                    let layer = new WMSLayer({
                        title: mapLayer.name,
                        description: mapLayer.description,
                        url: layerUrl,
                        opacity: mapLayer.conf.opacity,
                        sublayers: mapLayer.conf.sublayers
                    });
                    
                    // Agregar listener para errores de carga
                    layer.when(() => {
                        console.log(`[SgvMapComponent] Capa WMS '${mapLayer.name}' cargada correctamente`);
                    }).catch((error) => {
                        console.error(`[SgvMapComponent] Error al cargar capa WMS '${mapLayer.name}':`, error);
                        console.error(`[SgvMapComponent] URL usada: ${layerUrl}`);
                    });
                    //console.log('layer name', mapLayer.name)

                    layers.push(layer);
                } else {
                    console.warn(`[SgvMapComponent] Capa '${mapLayer?.name}' omitida: tipo no soportado`, mapLayer?.conf?.type);
                }
            }
           
            const view = new MapView({
                center: [myMapConfig.sgvmapMap.mapConfig.center.longitude, myMapConfig.sgvmapMap.mapConfig.center.latitude],
                scale: myMapConfig.sgvmapMap.mapConfig.scale,
                constraints: {
                    maxScale: myMapConfig.sgvmapMap.mapConfig.maxScale
                },
                container: mapRef.current,
                map: new Map({
                    basemap: basemap,
                    ground: "world-elevation",
                    layers: layers
                }),
                spatialReference: {
                    wkid: 3857
                }
            });
            window.mapView = view;


            const searchModel = new SearchVM({ view, popupEnabled: false });

            let symbol = {
                type: "simple-marker",
                style: "square",
                color: "blue",
                size: "15px",
                outline: {
                    color: [255, 255, 0],
                    width: 3
                }
            };
            searchModel.defaultSymbols = {
                point: symbol
            };

            const scaleBar = new ScaleBar({
                view: view,
                unit: "metric",
                style: "ruler"
            });
            view.ui.add(scaleBar, {
                position: "bottom-left"
            });

            const homeBtn = new Home({
                view: view
            });

            // Add the home button to the top left corner of the view
            view.ui.add(homeBtn, "top-left");

            let compass = new Compass({
                view: view
            });

            // adds the compass to the top left corner of the MapView
            view.ui.add(compass, "top-left");

            const locateBtn = new Locate({
                view: view
            });

            // Add the locate widget to the top left corner of the view
            view.ui.add(locateBtn, {
                position: "top-left"
            });

            const ccWidget = new CoordinateConversion({
                view: view,
                multipleConversions: false
            });

            //ccWidget.formats.map((format) => format.name == "xy" ? format.name = "WGS84" : format)


            view.ui.add(ccWidget, { position: "bottom-right", index: 2 });

            setMapView(view);
            setSearchVM(searchModel)

           
            //*******************************************************************
            // Watching properties for changes
            // 1. Watch view.stationary property
            // 2. Watch visible property of popup
            //*******************************************************************
            // Watch view's stationary property for becoming true.
            reactiveUtils.when(
                () => view.stationary === true,
                async () => {
                    let objectView = {
                        center: [],
                        scale: undefined
                    }
                    
                    // Get the new center of the view only when view is stationary.
                    if (view.center) {
                        const info = `the view center changed. x: ${view.center.x} y: ${view.center.y}`;
                        //console.log(info)

                        const point = new Point({
                            x: view.center.x,
                            y: view.center.y,
                            spatialReference: { wkid: 3857 }
                        });

                        const coordenadas = await convertToWGS84(point).then(
                            (coordenadas) => {
                                return coordenadas
                            }
                        )

                        objectView.center.push(coordenadas[0].toFixed(3))
                        objectView.center.push(coordenadas[1].toFixed(3))
                    }

                    if (view.scale) {
                        objectView.scale = view.scale
                    }
                    if (view.extent) {
                        //console.log('extent pi')
                        setExtent(view.extent)
                    }

                    //console.log('current view', currentView)
                    dispatch(addView(objectView))

                    //console.log("--------------------------------")
                }
            );

           

        }
    };

    const setMapConfigCallBack = (mapView) => {
        initMap(mapView);
    };

    let desktopToolbarStyle = {
        position: "absolute",
        top: "90%",
        right: "20px",
        /*left: "60px",*/
        zIndex: 1,
        textAlign: "center"
    }

    function getMapContentStyle() {
        if (isMobile) {
            //Si estamos en movil, sobreescribimos los containers de esri para ajustarlos
            var esriTopLeft = document.getElementsByClassName('esri-ui-top-left');
            for (var i = 0; i < esriTopLeft.length; i++) {
                esriTopLeft[i].style.top = '0px';
            }

            var esriBottomLeft = document.getElementsByClassName('esri-ui-bottom-left');
            for (var i = 0; i < esriBottomLeft.length; i++) {
                esriBottomLeft[i].style.bottom = '50px';
            }


            return {
                position: "absolute",
                top: "60px",
                bottom: "0px",
                left: "0px",
                right: "0px"
            }
        }
        else {
            return {
                minHeight: "100vh",
            }
        }
    }

    //console.log("sgvmap40_splitPos", localStorage.getItem('sgvmap40_splitPos'))
    return (
        <>

            <Layout>
                <Content
                    style={getMapContentStyle()}>

                    {
                        mapRef && mapView &&
                
                        <ToolBarComponent mapDiv={mapRef} mapView={mapView} table={tableRef.current}
                            mapConfig={mapConfig}
                            setMapConfig={setMapConfig} mapCallBack={setMapConfigCallBack}
                            tableVisible={tableVisible} setTableVisible={setTableVisible}
                            setCoordenadas={setCoordenadas}
                            overviewMapVisible={overviewMapVisible} setOverviewMapVisible={setOverviewMapVisible}
                            setBaseMap={setBaseMap} />
             
                    }
                    {
                        mapView && buttonPostView &&
                        <ButtonPostView view={mapView} ref={buttonPostView} setMapView={setMapView} currentView={currentView} setCurrentView={setCurrentView}></ButtonPostView>
                    }
                    {
                        mapView && buttonPreView &&
                        <ButtonPreView view={mapView} ref={buttonPreView} setMapView={setMapView} currentView={currentView} setCurrentView={setCurrentView}></ButtonPreView>
                    }
                    {
                        overviewMapVisible && mapView && overviewDivRef &&
                        <OverviewMapComponent view={mapView} ref={overviewDivRef} basemap={basemap} extent={extent} />
                    }
                    <SplitPane split="horizontal"
                        minSize={50}
                        size={
                            tableVisible ? localStorage.getItem('sgvmap40_splitPos') ? parseInt(localStorage.getItem('sgvmap40_splitPos')) : "50%" : "100%"
                        }
                        defaultSize={
                            tableVisible ? localStorage.getItem('sgvmap40_splitPos') ? parseInt(localStorage.getItem('sgvmap40_splitPos')) : "50%" : "100%"
                        }
                        onChange={(size) => {
                            setTableSize(window.innerHeight - size)
                            console.log("set splitPos", size)
                            localStorage.setItem('sgvmap40_splitPos', size + "");
                        }}>
                        <Pane className="">
                            <div ref={mapRef} className="mapView" ></div>
                        </Pane>
                        <Pane className="">
                            <TableComponent ref={tableRef} tableSize={tableSize} mapDiv={mapRef} mapView={mapView} tableVisible={tableVisible} setTableVisible={setTableVisible}></TableComponent>
                        </Pane>
                    </SplitPane>
                </Content>
            </Layout>

        </>
    )
}
export default SgvMapComponent;